import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import ContactModalForm from "./ContactModalForm";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ContactModal = ({ isOpen, onClose }: ModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [showModal, setShowModal] = useState(isOpen);

  // Mount modal when opening
  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
    }
  }, [isOpen]);

  // Handle GSAP animations
  useEffect(() => {
    if (showModal && isOpen && modalRef.current) {
      // OPEN animation
      gsap.fromTo(
        modalRef.current,
        { x: "100%" },
        { x: "0%", duration: 0.6, ease: "power3.out" }
      );
    }

    if (!isOpen && modalRef.current) {
      // CLOSE animation
      gsap.to(modalRef.current, {
        x: "100%",
        duration: 0.7,
        ease: "power3.inOut",
        onComplete: () => setShowModal(false),
      });
    }
  }, [isOpen, showModal]);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[100] flex">
      {/* Background overlay with blur */}
      <div
        className="absolute inset-0 bg-[#0d1821]/80 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Drawer modal */}
      <div
        ref={modalRef}
        className="relative flex items-center justify-center z-10 h-full text-[#0d1821] bg-[#f5f5f5] p-8 md:p-16 w-full sm:w-[40%] ml-auto rounded-l-[90px]"
      >
        <ContactModalForm />

        {/* Close button */}
        <button
          className="absolute top-[40px] right-[40px] text-[#0d1821] hover:text-[#00a878] border-2 border-[#0d1821]/50 rounded-full hover:border-[#00a878]"
          onClick={onClose}
        >
          <div className="p-[6px] h-10 w-10 text-xl">✕</div>
        </button>
      </div>
    </div>
  );
};

export default ContactModal;
